import { Trees } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-emerald-900/30 bg-[#040B11]/80 backdrop-blur"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-2 gap-6 items-center">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-emerald-900/40 border border-emerald-700/40">
            <Trees className="w-5 h-5 text-amber-400" />
          </span>
          <div>
            <p className="font-serif text-xl text-white">
              forestdays<span className="text-amber-400">.shop</span>
            </p>
            <p className="text-xs text-emerald-100/50">
              99 Nights in the Forest · Survival made simple.
            </p>
          </div>
        </div>
        <p className="text-xs text-emerald-100/40 md:text-right">
          © {new Date().getFullYear()} forestdays.shop · Not affiliated with Roblox Corporation.
        </p>
      </div>
    </footer>
  );
}
